import { createContext, useContext } from "react";

import { AuthorisationHelper } from "./AuthorisationHelper.ts";

export const AuthorisationContext = createContext<AuthorisationHelper>(
  {} as AuthorisationHelper
);

export const useAuthorisationContext = () => useContext(AuthorisationContext);
